import { render } from "./Project.vue?vue&type=template&id=5d7b87ce"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=5d7b87ce&lang=scss"
script.render = render

export default script